module.exports = __webpack_public_path__ + "img/hospital3.0016553b.png";